import React from "react";
import NonIndividualKycWrapper from "./NonIndividualKycWrapper";
import IndividualKycWrapper from "./IndividualKycWrapper";
import JBIndividualKycWrapper from "./JBIndividualKycWrapper";
import IndividualKycModeWrapper from "./IndividualKycModeWrapper";
interface KycStepsWrapperProps {
  bidderUuid: any;
  stepValue: string;
}

export default function KycStepsWrapper({
  bidderUuid,
  stepValue,
}: KycStepsWrapperProps) {
  if (
    process.env.NEXT_PUBLIC_ENABLE_ONLINE_JOINT_BIDDER_PARTICIPATION_FLOW !==
      "true" &&
    stepValue === "joint_individual"
  ) {
    return (
      <div className="h-full w-full text-center bg-white flex flex-col items-center justify-center rounded">
        <span>Coming soon</span>
      </div>
    );
  }
  return (
    <div className="bg-white">
      {!stepValue ? (
        <div className="flex flex-col flex-grow h-full">
          <div className="flex justify-center items-center">
            <div className="w-12 h-12 border-8 border-t-6 border-brand-orange rounded-full animate-spin bg-gradient-to-r from-brand-orange to-blue-100 shadow-lg"></div>
          </div>
        </div>
      ) : stepValue === "individual" ? (
        <IndividualKycModeWrapper bidderUuid={bidderUuid} />
      ) : stepValue === "non_individual" ? (
        <div className="py-4 px-4 bg-white rounded-lg">
          <NonIndividualKycWrapper bidderUuid={bidderUuid} />
        </div>
      ) : stepValue === "joint_individual" ? (
        <div className="py-4 px-4 bg-white rounded-lg">
          <JBIndividualKycWrapper bidderUuid={bidderUuid} />
        </div>
      ) : null}
    </div>
  );
}
